import dayjs from 'dayjs';

import { SurveyFieldType, SurveyVisibilityScope } from '../types';

const DEFAULT_VISIBILITY_LABEL = 'Wszyscy użytkownicy';

export const SURVEY_VISIBILITY_LABELS: Record<SurveyVisibilityScope, string> = {
  all: DEFAULT_VISIBILITY_LABEL,
  legalGuardian: 'Opiekunowie prawni',
  staffMember: 'Pracownicy',
};

export const SURVEY_VISIBILITY_OPTIONS: Array<{ value: SurveyVisibilityScope; label: string }> = [
  { value: 'all', label: SURVEY_VISIBILITY_LABELS.all },
  { value: 'legalGuardian', label: SURVEY_VISIBILITY_LABELS.legalGuardian },
  { value: 'staffMember', label: SURVEY_VISIBILITY_LABELS.staffMember },
];

export const getSurveyVisibilityLabel = (scope?: SurveyVisibilityScope | null) =>
  scope ? SURVEY_VISIBILITY_LABELS[scope] ?? DEFAULT_VISIBILITY_LABEL : DEFAULT_VISIBILITY_LABEL;

export const SURVEY_FIELD_TYPE_LABELS: Record<SurveyFieldType, string> = {
  textField: 'Pole tekstowe',
  textArea: 'Obszar tekstowy',
  radio: 'Wybór pojedynczy',
  checkbox: 'Wybór wielokrotny',
  scale: 'Skala ocen',
  divider: 'Separator',
};

export const getSurveyFieldTypeLabel = (type: SurveyFieldType) => SURVEY_FIELD_TYPE_LABELS[type];

export const formatSurveyDate = (value?: string | null) =>
  value ? dayjs(value).format('DD.MM.YYYY') : 'Bez ograniczenia';
